import { _throttle } from '@/util/common'

export default function () {
    return {
        data() {
            return {
                containerTop: 0,
            }
        },

        computed: {
            nextPageUrlWithScrollTop() {
                return `${this.getLoadNext}${this.containerTop}`
            }
        },

        watch: {
            nextPageUrlWithScrollTop: {
                handler() {
                    this.$nextTick(() => {
                        // 存在下一页数据且“加载提示”元素在可视区域内且当前非加载
                        const isHomePage = this.$route && this.$route.meta && this.$route.meta.name === '首页'
                        const hasNextPageAndIsInViewPort = !this.getLoading && this.getLoadNext && this.isInViewPort()

                        if (isHomePage && hasNextPageAndIsInViewPort) {
                            this.loadData()
                        }
                    })
                }
            },
            immediate: true
        },

        activated() {
            this.containerTop = 0.0001 // 挂载后主动触发下一页检测
            window.addEventListener('scroll', this.handleScroll)
        },

        deactivated() {
            window.removeEventListener('scroll', this.handleScroll)
        },

        methods: {
            handleScroll: _throttle(function () {
                this.containerTop = document.documentElement.scrollTop || document.body.scrollTop
                this.handleStickyHeader()
            }, 20),

            // 检查是否已滚动至底部视窗
            isScrolledToBottom() {
                return window.scrollY + window.innerHeight >= document.documentElement.scrollHeight
            },

            isInViewPort() {
                // 获取可视窗口的高度。
                const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                // 获取滚动条滚动的高度
                const scrollTop = document.documentElement.scrollTop

                const element = this.$refs.loadingRef.$el
                // 获取元素偏移的高度。就是距离可视窗口的偏移量。
                const offsetTop = element.offsetTop
                // 获取元素的高度。
                const elementHeight = element.offsetHeight
                // 高度1/2 作为差异阈值
                const halfElementHeight = elementHeight / 2

                return offsetTop - scrollTop <= screenHeight + halfElementHeight
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/homeLoadMoreMixin.js